import { render, staticRenderFns } from "./user-header-bar.vue?vue&type=template&id=2c704a19&scoped=true"
import script from "./user-header-bar.vue?vue&type=script&lang=js"
export * from "./user-header-bar.vue?vue&type=script&lang=js"
import style0 from "./user-header-bar.vue?vue&type=style&index=0&id=2c704a19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c704a19",
  null
  
)

export default component.exports